import script from "./TestimonyView.vue?vue&type=script&setup=true&lang=js"
export * from "./TestimonyView.vue?vue&type=script&setup=true&lang=js"

import "./TestimonyView.vue?vue&type=style&index=0&id=7e25ef20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e25ef20"]])

export default __exports__